import { ServicePage } from "../components/ServicePage";
import { IMAGES, AUTO_SERVICES } from "../lib/data";

export default function ConnexaAuto() {
  return (
    <ServicePage
      testid="connexa-auto-page"
      kicker="Connexa Auto"
      title="Connexa Auto"
      intro="Nuova, usata, importata o da configurare: troviamo la vettura giusta e ci occupiamo di ogni passaggio, fino a te."
      heroImg={IMAGES.autoShowcase}
      services={AUTO_SERVICES}
      gallery={[IMAGES.autoDark2, IMAGES.autoDark]}
      closingLine="La ricerca della tua auto ideale, gestita con la massima discrezione."
    />
  );
}
